import { Injectable } from '@angular/core';

@Injectable()
export class RiskConstantsService {

  constructor() { }

  public static ApiConstants = {
    GetAllMasterForRiskRaise: 'api/risk/get/allMasterForRiskRaise',
    RaiseRisk: 'api/risk/raise/riskRequest',
    GetRiskForDashboard: 'api/risk/get/riskForDashboard',
    GetAllActionByRiskRequestId: 'api/risk/get/actionDataByRiskRequestId',
    GetRiskRequestByRiskId: 'api/risk/get/riskRequestByRiskRequestId',
    GetRiskRequestPostEntityById: 'api/risk/get/getRiskRequestPostEntityById',
    UpdateActionDetailsByActionOwnerForRisk: 'api/hse/actionTracker/updateActionDetailsByActionOwnerForRisk',
    GetRiskRequestForEdit: 'api/risk/get/getRiskRequestForEdit',
    UpdateRisk: 'api/risk/update/RiskRequest',
    DeleteRisk: 'api/risk/delete/RiskRequest',
    GetCompletedActionByRiskId: 'api/risk/get/completedActionByRiskId',
    CloseRiskRequestByRiskId: 'api/risk/close/riskRequestByRiskId',
    GetActionPartyByActionId: 'api/risk/get/getActionPartyByActionId',
    DownloadPDF: 'api/hse/get/downloadpdf',
    SavePDF: 'api/hse/savepdf',
    UpdateActionsForRisk: 'api/risk/update/updateActionsForRisk',
    ExportToExcelOnRiskDashBoard: 'api/risk/get/exportToExcelRiskRequestOnRiskDashBoard',
    GetRiskControlTechniques: 'api/risk/get/riskControlTechniques',
    GetRiskRequestForEditByTool: 'api/risk/get/getRiskRequestForEditByTool',
    GetRiskRequestForToolId: 'api/risk/get/getRiskRequestForToolId',
    RaiseRiskForSelectedTool: 'api/risk/raise/riskRequestForSelectedTool',
    RaiseBulkRiskForSelectedTool: 'api/risk/raise/riskBulkRequestForSelectedTool',
    UpdateRiskForSelectedTool: 'api/risk/update/RiskRequestForSelectedTool',
    AuthorizeRiskForJSA: 'api/risk/authorize/AuthorizeRiskForJSA',
    AuthorizeRiskForMOC: 'api/risk/authorize/AuthorizeRiskForMOC',
    GetRiskForApproval: 'api/risk/get/riskForApproval',
    getIsValidForApprove:'api/risk/get/getIsValidForApprove',
    ImportRiskFromExcel: 'api/risk/ImportRiskFromExcel',
    ImportBulkRiskFromExcel: 'api/risk/ImportBulkRiskFromExcel',
    ExportRiskToExcel: 'api/risk/ExportRiskToExcel',
  };

  public static RiskSeverityHAZOP = [
    {
      Name: 'Please Select',
      Value: 0
    }, {
      Name: '1- Negligible/No Impact',
      Value: 1
    },
    {
      Name: '2- Minor',
      Value: 2
    },
    {
      Name: '3- Significant',
      Value: 3
    },
    {
      Name: '4- Severe',
      Value: 4
    },
    {
      Name: '5- Catastrophic',
      Value: 5
    },
  ];
  public static RiskLikelihoodHAZOP = [
    {
      Name: 'Please Select',
      Value: 0
    }, {
      Name: '1- Very Unlikely',
      Value: 1
    },
    {
      Name: '2- Unlikely',
      Value: 2
    },
    {
      Name: '3- Possible',
      Value: 3
    },
    {
      Name: '4- Likely',
      Value: 4
    },
    {
      Name: '5- Very Likely',
      Value: 5
    },
  ];
  public static InitialRiskSeverityHAZID = [
    {
      Name: 'Please Select',
      Value: 0
    }, {
      Name: '1- Negligible/No Impact',
      Value: 1
    },
    {
      Name: '2- Minor',
      Value: 2
    },
    {
      Name: '3- Significant',
      Value: 3
    },
    {
      Name: '4- Severe',
      Value: 4
    },
    {
      Name: '5- Catastrophic',
      Value: 5
    },
  ];
  public static InitialRiskLikelihoodHAZID = [
    {
      Name: 'Please Select',
      Value: 0
    }, {
      Name: '1- Very Unlikely',
      Value: 1
    },
    {
      Name: '2- Unlikely',
      Value: 2
    },
    {
      Name: '3- Possible',
      Value: 3
    },
    {
      Name: '4- Likely',
      Value: 4
    },
    {
      Name: '5- Very Likely',
      Value: 5
    },
  ];
  public static ResidualRiskSeverityHAZID = [
    {
      Name: 'Please Select',
      Value: 0
    }, {
      Name: '1- Negligible/No Impact',
      Value: 1
    },
    {
      Name: '2- Minor',
      Value: 2
    },
    {
      Name: '3- Significant',
      Value: 3
    },
    {
      Name: '4- Severe',
      Value: 4
    },
    {
      Name: '5- Catastrophic',
      Value: 5
    },
  ];
  public static ResidualRiskLikelihoodHAZID = [
    {
      Name: 'Please Select',
      Value: 0
    }, {
      Name: '1- Very Unlikely',
      Value: 1
    },
    {
      Name: '2- Unlikely',
      Value: 2
    },
    {
      Name: '3- Possible',
      Value: 3
    },
    {
      Name: '4- Likely',
      Value: 4
    },
    {
      Name: '5- Very Likely',
      Value: 5
    },
  ];
  public static Pear = ['People', 'Assets', 'Environment', 'Reputation', 'NPT'];
  public static Consequence = [
    {
      Name: 'No Values',
      Value: 0,
    }, {
      Name: 'A- Rare',
      Value: 'A',
    },
    {
      Name: 'B- Unlikely',
      Value: 'B',
    },
    {
      Name: 'C- Moderate',
      Value: 'C',
    },
    {
      Name: 'D- Likely',
      Value: 'D',
    },
    {
      Name: 'E- Probable',
      Value: 'E',
    }];
  public static PeopleSeverity = [
    {
      Name: 'No Health effect/Injury',
      Value: 0
    }, {
      Name: '1- Slight health effect/Injury',
      Value: 1
    },
    {
      Name: '2- Minor health effect/Injury',
      Value: 2
    },
    {
      Name: '3- Major health effect/Injury including LTI',
      Value: 3
    },
    {
      Name: '4- PTD or 1 fatality',
      Value: 4
    },
    {
      Name: '5- Multiple fatalities',
      Value: 5
    },
  ];
  public static EnvironmentSeverity = [
    {
      Name: 'No effect',
      Value: 0
    }, {
      Name: '1- Slight effect',
      Value: 1
    },
    {
      Name: '2- Minor effect',
      Value: 2
    },
    {
      Name: '3- Moderate effect',
      Value: 3
    },
    {
      Name: '4- Major effect',
      Value: 4
    },
    {
      Name: '5- Massive effect',
      Value: 5
    },
  ];
  public static AssetsSeverity = [
    {
      Name: 'No damage',
      Value: 0
    }, {
      Name: '1- Slight damage < US $50K',
      Value: 1
    },
    {
      Name: '2- Minor damage < US $500K',
      Value: 2
    },
    {
      Name: '3- Localised damage < US $2M',
      Value: 3
    },
    {
      Name: '4- Major damage < US $20M',
      Value: 4
    },
    {
      Name: '5- Extensive damage < US $20M',
      Value: 5
    },
  ];
  public static ReputationSeverity = [
    {
      Name: 'No concern',
      Value: 0
    }, {
      Name: '1- No concerns',
      Value: 1
    },
    {
      Name: '2- Individual concerns',
      Value: 2
    },
    {
      Name: '3- Local community attention',
      Value: 3
    },
    {
      Name: '4- National attention',
      Value: 4
    },
    {
      Name: '5- International attention',
      Value: 5
    },
  ];
  public static NPTSeverity = [
    {
      Name: '< 2',
      Value: 0
    }, {
      Name: '> 2 & < 6',
      Value: 1
    },
    {
      Name: '> 6 & < 12',
      Value: 2
    },
    {
      Name: '> 12 & < 24',
      Value: 3
    },
    {
      Name: '> 24 & < 48',
      Value: 4
    },
    {
      Name: '> 48',
      Value: 5
    },
  ];
  public static RiskMovement = ['Increasing', 'Decreasing', 'Stable'];

  public static RiskType = {
    Potential: 'Potential',
    Residual: 'Residual',
    Assessment: 'Assessment'
  };

  public static Status = {
    New: 'New',
    Closed: 'Closed',
    Pending: 'Pending'
  };

  public static RedirectUrls = {
    MyRiskRequest: '/risk/risk-overview',
    ResidualRiskRequest: '/risk/residual-risk-dashboard',
    RiskForApproval: '/risk/risk-Approval'
  };

  public static OrderByColoumnName = {
    CreatedDate: 'Created Date',
    RiskRating: 'Risk Rating'
  };

  public static OrderBy = {
    ASC: 'ASC',
    DESC: 'DESC'
  };
  public static RiskIdentified = [
    {
      Id: 'Intolerable (Red)',
      Colour: 'intolerable',
      Value: ['3E', '4D', '4E', '5C', '5D', '5E'],
      Check: false
    },
    {
      Id: 'Tolerable (Yellow)',
      Colour: 'tolerable-yellow',
      Value: ['1C', '1D', '1E', '2B', '2C', '3A', '3B', '4A'],
      Check: false
    },
    {
      Id: 'Tolerable (Orange)',
      Colour: 'tolerable-orange',
      Value: ['2D', '2E', '3C', '3D', '4B', '4C', '5A', '5B'],
      Check: false
    },
    {
      Id: 'Acceptable (Green)',
      Colour: 'acceptable',
      Value: ['1A', '1B', '2A'],
      Check: false
    }
  ];

  public static PearForDashboard =
    [{
      Id: 'People',
      Checked: false
    },
    {
      Id: 'Reputation',
      Checked: false
    },
    {
      Id: 'Assets',
      Checked: false
    },
    {
      Id: 'Environment',
      Checked: false
    },
    {
      Id: 'NPT',
      Checked: false
    }];

  public static RiskRequest = {
    RiskRequestId: 'riskRequestId',
    RSK: 'RSK',
    RaiseRisk: 'Raise Risk',
  };

  public static RoutingURLConstant = {
    AllActionsDashboardURL: '/actiontracker/actions-overview'
  };

  public static Alert = {
    ConfirmationMessage: 'You are going back to dashboard. Information entered by you will not be saved. Do you want to continue? '
  };

  // Side bar routesURL and routeName of Risk
  public static RiskNavigation = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Raise Risk',
        routeURL: '/risk/raise-risk/new',
        isClickable: true
      },
      {
        routeName: 'Risk Register',
        routeURL: '/risk/risk-overview',
        isClickable: true
      },
      // {
      //   routeName: 'Pending for closure',
      //   routeURL: '/risk/pending-for-closure'
      // },
      // {
      //   routeName: 'Residual risks',
      //   routeURL: '/risk/residual-risk-dashboard'
      // }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../../home',
        isClickable: true
      },
      {
        routeName: 'Raise Risk',
        routeURL: '/risk/raise-risk/new',
        isClickable: true
      },
      {
        routeName: 'Risk Register',
        routeURL: '/risk/risk-overview',
        isClickable: true
      },
      // {
      //   routeName: 'Pending for closure',
      //   routeURL: '/risk/pending-for-closure'
      // },
      // {
      //   routeName: 'Residual risks',
      //   routeURL: '/risk/residual-risk-dashboard'
      // }
    ],
    ReportRoutes: [
    ]
  };

  public static AlphabeticalToNumber = {
    Alphabet: [
      {
        Id: 1,
        Character: 'A'
      },
      {
        Id: 2,
        Character: 'B'
      },
      {
        Id: 3,
        Character: 'C'
      },
      {
        Id: 4,
        Character: 'D'
      },
      {
        Id: 5,
        Character: 'E'
      },
      {
        Id: 0,
        Character: '0'
      }
    ]
  };
}
